import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Box, Alert, Button } from '@mui/material';
import QuizTaker from '../../components/quiz/QuizTaker';
import { useQuiz } from '../../contexts/QuizContext';

const QuizTaking: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { clearTakingState } = useQuiz();
  
  const quizId = id ? parseInt(id) : null;

  useEffect(() => {
    // Clear any previous quiz state when component mounts
    clearTakingState();
  }, [clearTakingState]);

  if (!quizId || isNaN(quizId)) {
    return (
      <Container maxWidth="md">
        <Box py={4}>
          <Alert severity="error" sx={{ mb: 2 }}>
            ID bài tập không hợp lệ
          </Alert>
          <Button
            variant="contained"
            onClick={() => navigate('/quizzes')}
          >
            Quay lại danh sách bài tập
          </Button>
        </Box>
      </Container>
    );
  }

  return <QuizTaker quizId={quizId} />;
};

export default QuizTaking;
